import { render, staticRenderFns } from "./BookingCategories.vue?vue&type=template&id=eb37d854&scoped=true&"
import script from "./BookingCategories.vue?vue&type=script&lang=js&"
export * from "./BookingCategories.vue?vue&type=script&lang=js&"
import style0 from "@/assets/less/manage-space/base.less?vue&type=style&index=0&id=eb37d854&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb37d854",
  null
  
)

export default component.exports